var map = {
	"./alex.png": "8162",
	"./aline.jpg": "9b82",
	"./cristiana.png": "0bca",
	"./diana.png": "38ca",
	"./kody.jpg": "72fa",
	"./marcus.jpg": "0958",
	"./pedro.jpeg": "8b47",
	"./ruta.jpeg": "887a",
	"./tobias.jpeg": "7901",
	"./walter.jpg": "a2cb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7fe5";